<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <JhMemberInfo :member-info="memberInfo" />

    <div style="margin-top: 20px;">
      <QyMemberList :qy-member-list="memberInfo.qyMemberList || []" />
    </div>

    <div style="margin-top: 20px;">
      <QyOrderList :qy-order-list="memberInfo.qyOrderList || []" />
    </div>

    <div style="margin-top: 20px;">
      <QyMemberContactList :qy-member-contact-list="memberInfo.qyMemberContactList || []" />
    </div>
  </div>
</template>

<script>
import { getDetailAPI } from "./api";
import JhMemberInfo from "@/views/user-manage/member/modules/jh-member-info.vue";
import QyMemberList from "@/views/user-manage/member/modules/qy-member-list.vue";
import QyOrderList from "@/views/user-manage/member/modules/qy-order-list.vue";
import QyMemberContactList from "@/views/user-manage/member/modules/qy-member-contact-list.vue";

export default {
  name: "MemberDetail",

  components: {
    JhMemberInfo,
    QyMemberList,
    QyOrderList,
    QyMemberContactList,
  },

  data() {
    return {
      memberInfo: {},
    }
  },

  provide() {
    return {
      context: this
    }
  },

  mounted() {
    this.getDetailAPI();
  },

  methods: {
    async getDetailAPI() {
      this.memberInfo = await getDetailAPI(this.$route.params.id);
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .blacklist {
    color: #ffffff;
    background-color: #000000;
    font-weight: bold;
  }
}
</style>
